<template>
  <v-footer inset app absolute class="hidden-print">
    <!-- 普通屏幕尺寸 -->
    <v-row no-gutters class="d-none d-sm-flex my-n1">
      <span class="px-1">
        {{ company }} &copy; {{ startYear }} -
        {{ new Date().getFullYear() }}</span
      >
      <span class="px-1">
        <a target="_blank" href="http://beian.miit.gov.cn/">
          {{ beian }}
        </a>
      </span>
      <span v-if="gnbeian" class="px-1">
        <a target="_blank" :href="gnbeianurl">
          <v-img
            :src="require('./assets/beianicon.png')"
            height="16"
            width="16"
            class="float-left"
          />{{ gnbeian }}
        </a>
      </span>
    </v-row>
    <!-- 手机小屏幕 -->
    <v-tooltip top open-on-hover>
      <template v-slot:activator="{ on, attrs }">
        <v-row no-gutters v-bind="attrs" v-on="on" class="d-flex d-sm-none">
          <span class="px-1" style="font-size: 8px">
            {{ company }} &copy;
          </span>
          <span class="px-1" style="font-size: 8px">
            <a target="_blank" href="http://beian.miit.gov.cn/">
              {{ beian }}
            </a>
          </span>
          <span v-if="gnbeian" class="px-1" style="font-size: 8px">
            <a target="_blank" :href="gnbeianurl">
              <v-img
                :src="require('./assets/beianicon.png')"
                height="16"
                width="16"
                class="float-left"
              />{{ gnbeianshort }}
            </a>
          </span>
        </v-row>
      </template>
      <span>
        {{ company }} &copy; {{ startYear }} - {{ new Date().getFullYear()
        }}<br />
        {{ beian }}<br />
        <v-img
          v-if="gnbeian"
          :src="require('./assets/beianicon.png')"
          height="20"
          width="20"
          class="float-left"
        />{{ gnbeian }}
      </span>
    </v-tooltip>
  </v-footer>
</template>

<script>
export default {
  name: "Footer",

  computed: {
    company() {
      switch (this.$LogoFolder) {
        case "fengputech/":
          return "蜂铺科技";
      }
      return this.$t("company");
    },
    startYear() {
      switch (this.$LogoFolder) {
        case "fengputech/":
          return "2022";
      }
      return "2016";
    },
    beian() {
      switch (this.$LogoFolder) {
        case "fengputech/":
          return "沪ICP备2022004271号-1";
      }
      return "沪ICP备12041198号";
    },
    gnbeian() {
      switch (this.$LogoFolder) {
        case "fengputech/":
          return "";
      }
      return "沪公网安备31011502011513号";
    },
    gnbeianshort() {
      switch (this.$LogoFolder) {
        case "fengputech/":
          return "";
      }
      return "沪公网安备";
    },
    gnbeianurl() {
      switch (this.$LogoFolder) {
        case "fengputech/":
          return "";
      }
      return "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502011513";
    },
  },
};
</script>

<i18n>
{
  "zhHans": {
    "company": "一言为订"
  },
  "en": {
    "company": "YYWD"
  }
}
</i18n>